import { IBonusBuyInitData } from '@GFTypes/index';
import { IAuthenticateResponseData } from '@GFTypes/Responses/AuthenticateResponse';

export const processBonusBuyData = (data: IAuthenticateResponseData): IBonusBuyInitData | undefined => {
    const bonusBuy = data.actionBets?.bonusbuy_spin;
    if (!bonusBuy) {
        return undefined;
    }

    let bonusBuyData;
    bonusBuyData = {
        bonusbuy_spin: {
            default: bonusBuy?.default ?? 0,
            steps: bonusBuy?.steps ?? []
        }
    };
    return bonusBuyData;
};
